import React ,{ useState ,useEffect} from "react";
import { Grid, GridColumn , Image, GridRow , Icon, Container, Button ,Popup , Embed , Divider ,Label , LabelDetail, Header} from "semantic-ui-react"
import { useQuery } from "@apollo/client";
//import { GET_USER } from "../../../gql/user";
import { renderToString } from 'react-dom/server';
//import userAuth from "../../../hooks/useAuth";
import PublicationNot from "../../Publicatex/Main/PublicationNot/PublicationNot"
import ModalBasic from "../../../../components/ModalBasic/ModalBasic";

import ModalFoto from "../ModalFoto/ModalFoto"
import WhatSend from "../../WhatSend";
import Slider from "../../../PublicationDes/Slider/Slider";
//import  ActionsVent from "../../../../components/ModalPublicasion /ActionsVent/ActionsVent"
import ActionVent from "../ModalFoto/ActionVenta/ActionVent";
import Plataforma from "../Main/Plataformas/Plataforma"
import {Link} from "react-router-dom"
import "./Main.scss";
import { get } from "lodash";
import { GET_PUBLICATION } from "../../../../gql/publication";
import { useMutation } from '@apollo/client';
import { PUBLIC_COMPLET } from '../../../../gql/publication';
import icona from "../../../../asets/png/icona.jpg"
import gans from "../../../../asets/png/gans.png"
import avejasy from "../../../../asets/png/avejasy.jpeg"
import abejayoutube from "../../../../asets/png/abejayoutube.jpeg"
//import {  Helmet ,  HelmetProvider  }  from "react-helmet-async"
import SEO from "../../../../SEO";
import { HeadProvider, Title, Meta, Base, Link as Link1} from 'react-head';
//import Smagen from "../../../../components/Smagen";
import  ReactDOM  from  'react-dom' ;

export default function Profile (props){
 const { idPublication} = props ;
 const [showModal, setShowModal] = useState(false);
 const [showModalFoto, setShowModalFoto] = useState(false);
 const [completPublic] = useMutation (PUBLIC_COMPLET);
 //const [publicationSelect, setPublicationSelect ] = useState (null);
 const [titleModal , setTitleModal] = useState("");
 const [childrenModal, setChildrenModal]=  useState(null) ;
 //const [count, setCount] = useState(parseInt(getPublicate[0].count) + 1 )
 //const {auth} = userAuth ();
 const [wha ,setWha] = useState (null);

 const contextRef = React.useRef()
 const [open, setOpen] = React.useState(false)

 useEffect(() => {
 // console.log ("hola ")

     
   //console.log ("hi")

   //console.log (completPublic)
     try {
        completPublic({
         variables:{	input:{
           idPublication:idPublication,
           count:getPublicate[0].count +1
         }},

            
       });
       
       
     } catch (error) {
       console.log (error);
       
     }
 
}, [])



 const { data, loading, error, refetch} = useQuery (GET_PUBLICATION,{
  variables: { id:idPublication } ,
});

 

 if (loading) return null ;
 if (error) return <PublicationNot/>;
 const { getPublicate } = data;

 



 //console.log(idPublication);
 //console.log(data)
 
 const id = idPublication ;
 console.log(getPublicate[0].file);
 
 const handlerModal = (type) => {
  switch (type) {
    
       case "Ubicasion" :
       setTitleModal ("Este articulo lo puedes adquirir en ");
        setChildrenModal( <h2>{getPublicate[0].area}</h2>);
        setShowModal(true);
        break; 
        case "Enviar":
          setTitleModal("Manda un mensaje al vendedor ");
          setChildrenModal( <WhatSend publication={getPublicate}   />);
          
          setShowModal(true);
          break;

          case "precio":
            setTitleModal("Precio publicado ");
            setChildrenModal( getPublicate[0].ofertPre ? <h2>Oferta 💲 {getPublicate[0].ofertPre}mn. 😀  </h2> :<h2>💲  {getPublicate[0].precio} mn.</h2>  );
            //setChildrenModal(  );
            setShowModal(true);
            break;
            case "Plataforma":
              setTitleModal("Plataformas disponibles ");
              setChildrenModal( <Plataforma publication={getPublicate}   />);
              
              setShowModal(true);
              break;


    default:
      break;
  }

 }


 const openPublication = (publication) => {
  //setPublicationSelect(publication);
  
  setShowModalFoto(true);

};



 return(
    
<>
<HeadProvider>
   
<Title>{getPublicate[0].title}</Title>  

<Meta name="description" content={getPublicate[0].description}/>


<Meta property="og:url" content="https://lacolme.shop"/>
<Meta property="og:type" content="website"/>
<Meta property="og:title" content={getPublicate[0].title}/>
<Meta property="og:description" content="compra vende y cambia"/>
<Meta property="og:image" content={getPublicate[0].file}/>


<Meta name="twitter:card" content="summary_large_image"/>
<Meta property="twitter:domain" content="lacolme.shop"/>
<Meta property="twitter:url" content="https://lacolme.shop"/>
<Meta name="twitter:title" content="La colme"/>
<Meta name="twitter:description" content = {getPublicate[0].description} />
<Meta name="twitter:image" content={getPublicate[0].file}/>


    

    
</HeadProvider> 
  
    <div className="Publication ">
    
    <GridRow className=" Publication-header" centered computer={5}  mobile= {16} height= {1} > <h2>{getPublicate[0].title} </h2></GridRow>
    <Grid >
    <GridRow>

    <GridColumn computer= {5}  mobile = {16}className= "Publication-left">
      <Image src = {getPublicate[0].file}  medium rounded image    onClick={ ()=> openPublication ( )}  />
    </GridColumn>
     <GridColumn computer ={6}  mobile={16}className = "Publication_center">
     <Container className="starts">
     
   <Icon name= "star" />

   <Popup
    trigger={<Icon name='star' color='#fff' size='small' circular  />}
    content={  <span>Vistas  👁️ {getPublicate[0].count}</span>}
    
  />


  

    <Icon name= "star"/>
    
    </Container>
      <Container textAlign='justified' >
          
     <h2> DESCRIPCION </h2>
          {getPublicate[0].description && (
            <p>{getPublicate[0].description}</p>

          )}
      </Container>
      <ActionVent publication= {id}/>

<Container className="menuicon">
<div>
<Icon name= "map pin"  onClick={()=>handlerModal("Ubicasion")}  />
<span> { getPublicate[0].area}</span>
</div>


<div>
<Icon name= "whatsapp square" onClick={()=>handlerModal("Enviar")} />
<span> Enviar whatsapp </span>
</div>
</Container>
<Container className="menuicon">
<div>
<a href = {`whatsapp://send?text= %20 Hola❗%20👋..  Mira esto... %20%20 💥${getPublicate[0].title}💥%20 %20 %20 ¡Esta Padre!%20 %20 https://www.lacolme.com/publication/${idPublication} %20🤩`}  
 
target= "{getPublicate[0].file}"
rel=""
       >
  
<Icon name= "share square"></Icon>

</a>
<span>Compartir en whats</span>
</div>

<div>
<Icon name= "dollar"  onClick={()=>handlerModal("precio")}
/>
<span> Consulta el precio </span>

</div>

</Container>
  
</GridColumn>


<GridColumn computer= {5}  mobile = {16} className= "video">

<Divider />

 
  {(<h2> { getPublicate[0].video ? "Video Demostracion" : "Sin Video  "}  </h2>)}

   { getPublicate[0].video ?  <Embed
         
         icon='youtube'
         id={getPublicate[0].video}
         placeholder={abejayoutube}
         source='youtube'


       /> : <></>}
       




<Divider hidden />
        

        
{(<> { getPublicate[0].video ? <></> :  <Image src = {avejasy}/> }  </>)}
<Divider hidden />
<Container className="labo">
<Label color="teal" >
{( <>{getPublicate[0].ofertPre ?  " OFERTA 🤑 ": "🤝 😎 🤝"  } </> )}
</Label>
<Label  >

👁️ Vistas  {getPublicate[0].count}
</Label>
<Label as='a' color='red' >

{( <>{getPublicate[0].ofertPre ?  <span>💲 {getPublicate[0].ofertPre }</span>: "🤝 😎 🤝"  } </> )}
</Label>


     

</Container>
<Container className="lab"mobile= {2}>
<Popup
    trigger={<Icon name='star' color='#fff' size='small' circular  />}
    content={  <span> 🐝</span>}
    
  />

<Popup 
trigger={<Button color='blue' compact onClick={()=>handlerModal("Plataforma")} > Plataformas  </Button>
} flowing hoverable>

    <Grid centered divided columns={1} mobile= {1} >
   
      <GridColumn textAlign="center" >
      
      
        <span>
          <b>Adquierelo en ..  </b> 
        </span>

        
 </GridColumn>
      
      
    </Grid>
  </Popup>


  <Popup
    trigger={<Icon name='star' color='#fff' size='small' circular  />}
    content={  <span>🐝</span>}
    
  />






     
</Container>

<Divider />



    </GridColumn>


      
</GridRow>







 </Grid>

 <Container fluid className="Publication_stado">

  
  <Icon name="certificate" />
  
  
  <span>{getPublicate[0].estado}</span>
  <Icon name="certificate" />
</Container>







     
     <ModalBasic show={showModal} setShow={setShowModal} title = {titleModal}>
     {childrenModal}
      

     </ModalBasic>

     
     {showModalFoto && (
      <Slider show= {showModalFoto}  setShow= {setShowModalFoto}   getPublicate={getPublicate}  id={idPublication} /> )};
      
      


     </div>
     </>
      
);

}


